/* eslint-disable */
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";
import {
  ProducttagsList,
  ProducttagsListVariables
} from "./types/ProducttagsList";
import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import { TypedQuery } from "@saleor/queries";
import { Producttag, ProducttagVariables } from "./types/Producttag";

const producttagsList = gql`
  ${pageInfoFragment}
  query ProducttagsList(
    $after: String
    $first: Int
    $last: Int
    $before: String
    $filter: ProductTagsFilterInput
  ) {
    producttags(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      edges {
        node {
          id
          tagId
          title
          tagType
          name
          stickersImage
          stickersImageLocationX
          stickersImageLocationY
          showTag
          componentFontColor
          productFontColor
          productBackgroundColor
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
    }
  }
`;
export const useProducttagsListQuery = makeQuery<
  ProducttagsList,
  ProducttagsListVariables
>(producttagsList);
const producttag = gql`
  ${pageInfoFragment}
  query Producttag(
    $id: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
  ) {
    producttag(id: $id) {
      id
      name
      title
      tagType
      stickersImage
      stickersImageLocationX
      stickersImageLocationY
      showTag
      componentFontColor
      productFontColor
      productBackgroundColor
      products(first: 20, before: $before, after: $after, last: $last) {
        edges {
          node {
            id
            name
            thumbnail {
              url
            }
            productType {
              name
            }
            isPublished
          }
        }
        pageInfo {
          ...PageInfoFragment
        }
        totalCount
      }
      variants(first: 20, before: $before, after: $after, last: $last) {
        edges {
          node {
            id
            name
            product {
              id
              name
            }
            sku
            skuName
            isPublished
            thumbnail {
              url
            }
          }
        }
        pageInfo {
          ...PageInfoFragment
        }
        totalCount
      }
      categories(after: $after, before: $before, first: $first, last: $last) {
        edges {
          node {
            id
            name
            products {
              totalCount
            }
          }
        }
        pageInfo {
          ...PageInfoFragment
        }
        totalCount
      }
      collections(after: $after, before: $before, first: $first, last: $last) {
        edges {
          node {
            id
            name
            products {
              totalCount
            }
          }
        }
        pageInfo {
          ...PageInfoFragment
        }
        totalCount
      }
    }
  }
`;
export const TypedproducttagQuery = TypedQuery<Producttag, ProducttagVariables>(
  producttag
);
